<template>
    <div class="armory-defense-container">
        <div class="grid-cards">
            <DefenseArmoryCardComponent v-for="defense in this.defenses" 
                :key=defense.defenseTypeId 
                v-bind="defense"
                v-model:planetQueue="defense.planetQueue" 
            />
        </div>
    </div>
</template>

<style scoped>
.armory-defense-container{
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.grid-cards {
    display: grid;
    grid-auto-rows: 1fr;
    grid-template-columns: repeat(auto-fit, minmax(352px, 1fr));
    gap: 24px;
    width: 100%;
}

@media screen and (max-width: 640px) {
    .grid-cards {
        grid-template-columns: repeat(auto-fit, minmax(311px, 1fr));
    }
}
</style>

<script>
import { sprintf } from 'sprintf-js';

import * as mercureTopicConstant from '@/constants/mercureTopicConstant';

import { userLoginDataStorage } from '@/storages/userLoginDataStorage';

import DefenseArmoryCardComponent from '@/components/DefenseArmoryCardComponent.vue';

export default {
    name: 'DefenseArmoryView',
    components: {
        DefenseArmoryCardComponent
    },
    setup() {
        const userLoginDataStorageInstance = userLoginDataStorage();
        return {
            userLoginDataStorageInstance,
            mercureTopicConstant
        }
    },
    data() {
        return {
            userId: this.userLoginDataStorageInstance.getUserId(),
            planetId: this.userLoginDataStorageInstance.getUserMainPlanetId(),
            defenses: [],
            mercureConnection: null,
        }
    },
    mounted() {
        this.getBuildings();
        this.cretateMercureEvent();
    },
    unmounted() {
        this.closeMercureEvent();
    },
    methods: {
        getBuildings() {
            this.$axios.getPlanetDefenses(this.planetId).then(response => {
                console.log("Response data:", response.data);
                console.log("Response code:", response.status);
                console.log("Response headers:", response.headers);
                this.defenses = response.data.defenseDataCollection;
            }).catch(error => {
                console.error("Error defenses request:", error);
            });
        },
        cretateMercureEvent()
        {
            this.mercureEvent = this.$mercure.createMercureEvent(
                sprintf(mercureTopicConstant.USER_DEFENSES_VIEW_TOPIC, this.userId)
            );

            this.mercureEvent.onmessage = event => {
                const data = JSON.parse(event.data);
                const key = this.defenses.findIndex(obj => obj.defenseTypeId === data.defenseTypeId);
                this.defenses.splice(key, 1, data);
                this.$globalEvent.updateUserPlanetResourceView(this.planetId);
            };
        },
        closeMercureEvent()
        {
            this.mercureEvent.close();
            this.mercureEvent = null;
        }
    }
}
</script>